import React, { useState } from "react";
import { RiAddBoxFill, RiEdit2Fill } from "react-icons/ri";
// import ActionReferralModal from "../modals/ActionRefferalModal";
import { usePatient } from "../../contexts";
import { useNavigate } from "react-router-dom";
import ProcedureEditsModal from "../modals/ProcedureEditsModal";
import Spinner from "../UI/Spinner";
import LabReport from "../modals/LabReport";
import LabReports from "../modals/LabReports";
import LabReportTable from "../modals/LabReports";
import TableSkeleton from "./TableSkeleton";
import LabReportTemplates from "../pages/LabReportPage";
import { get } from "../../utility/fetch";
import { Skeleton } from "@mui/material";

export default function ProcedureTable({ data, template, fetch, manage, color, currentTemplate, getProcedures, isWalkin, loading, currentPage, itemsPerPage, readOnly }) {
  const isMobile = window.innerWidth < 768;
  const { setPatientInfo } = usePatient()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [referralId, setRefferalId] = useState('');
  // const [loading, setLoading] = useState(false);
  const [referralInfo, setReferralInfo] = useState('');
  const navigate = useNavigate()
  const [showProcedureEditModal, setShowProcedureEditModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [referredPatients, setReferredPatients] = useState([
    {
      patientId: 'H3787',
      firstName: "John",
      lastName: "Doe",
      hospitalName: "General Hospital",
      doctor: "Dr. Smith",
      dateCreated: "2023-01-01",
      labWorkRequested: ["Blood Test", "X-Ray"],
      severity: "High",
      diagnosis: "Hypertension",
      timeInitiated: "10:00 AM",
      hmoCover: 2000000
    },
    {
      patientId: 'H3097',
      firstName: "Jane",
      lastName: "Doe",
      hospitalName: "City Clinic",
      doctor: "Dr. Brown",
      dateCreated: "2023-02-01",
      labWorkRequested: ["MRI", "CT Scan"],
      severity: "Medium",
      diagnosis: "Migraine",
      timeInitiated: "11:00 AM",
      hmoCover: 150000
    },
    {
      patientId: 'H3798',
      firstName: "Alice",
      lastName: "Johnson",
      hospitalName: "Health Center",
      doctor: "Dr. White",
      dateCreated: "2023-03-01",
      labWorkRequested: ["Ultrasound", "Blood Test"],
      severity: "Low",
      diagnosis: "Anemia",
      timeInitiated: "12:00 PM",
      hmoCover: 40000
    }
  ]);


  console.log(data);
  console.log(referralInfo)


  const { setPatientId } = usePatient();


  const openModal = () => {
    setIsModalOpen(true);
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setPatientInfo(null)
  };

  const continueUpdate = async (data) => {
    if (readOnly) {
      // setPatientId(id);
      // setPatientInfo(data)
      setLoadingReport(true);
      // let res = await get(`/walkinlabrequest/${data?.walkInLabRequestId}`);
      setLoadingReport(false);
      // console.log(res.data.walkInPatient.gender)
      // setReferralInfo({gender:res?.data?.walkInPatient?.gender, ...data});
      setReferralInfo(data);
      // setRefferalId(data?.referralId);
      setShowReportModal(true)
    }
    else {
      //  setPatientId(id);
      setPatientInfo(data)
      setReferralInfo(data);
      setRefferalId(data?.referralId);
      setShowProcedureEditModal(true)
    }

    // navigate('/procedure-edits')
  };

  // helper: compute completion status banner from walkInTestRequests / testRequests
  const renderCompletionBanner = (row) => {
    const requests = row?.walkInTestRequests ?? row?.testRequests ?? [];
    // if there are no requests treat as incomplete
    const allDone = Array.isArray(requests) && requests.length > 0 && requests.every(r => r?.isReportDone === true);
    const statusText = allDone ? 'COMPLETE' : 'INCOMPLETE';
    const styles = allDone
      ? { background: '#e6f9ee', color: '#15683a', border: '1px solid #c7efd0' } // green-ish
      : { background: '#fff4e6', color: '#a04f00', border: '1px solid #ffd8a8' } // orange-ish

    return (
      <td>
        <div style={{ display: 'inline-block', padding: '6px 10px', borderRadius: 8, fontWeight: 800, fontSize: 12, textTransform: 'uppercase', ...styles }}>
          {statusText}
        </div>
      </td>
    );
  };

  // Sort data by dateCreated in descending order
  const sortedData = [...data].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  if (isMobile) {
    return (
      <div className="w-100">
        <div className="tabs m-t-10 bold-text"></div>
        <div className="flex flex-col gap-12 m-t-20">
          {loading ? <TableSkeleton /> : (
            Array.isArray(data) && data.map(row => {
              const requests = row?.walkInTestRequests ?? row?.testRequests ?? [];
              const allDone = Array.isArray(requests) && requests.length > 0 && requests.every(r => r?.isReportDone === true);
              const statusText = allDone ? 'COMPLETE' : 'INCOMPLETE';
              const statusColor = allDone ? '#15683a' : '#a04f00';
              const statusBg = allDone ? '#e6f9ee' : '#fff4e6';

              return (
                <div key={row.id} className="card shadow-sm m-b-20" style={{ borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }}>
                  <div className="flex flex-h-between flex-v-center" style={{ padding: '15px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
                    <h4 className="m-0" style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>
                      {isWalkin ? `${(row?.walkInPatient?.firstName + " " + row?.walkInPatient?.lastName) || row?.patientFullName}` : `${row?.patient?.firstName} ${row?.patient?.lastName}`}
                    </h4>
                    <span style={{ fontSize: '12px', color: '#666' }}>ID: {isWalkin ? row?.walkInPatient?.walkInPatientRef : row?.patient?.id}</span>
                  </div>
                  <div style={{ padding: '15px' }}>
                    <div className="m-b-10">
                      <span className="text-uppercase text-muted block m-b-5" style={{ fontSize: '11px', fontWeight: 'bold', color: '#888' }}>LAB WORK</span>
                      {(row?.patientTestReports || row?.testRequests)?.map((work, i) => (
                        <div className="m-b-5" key={i} style={{ fontSize: '14px' }}>{i + 1}. {work?.internalLabService?.name || work?.referredInternalLabService?.name}</div>
                      ))}
                    </div>
                    <div className="flex flex-h-between flex-v-center">
                      <span style={{ fontSize: '12px', color: '#888' }}>{new Date(row?.createdOn || row?.createdAt).toLocaleDateString()}</span>
                      <span style={{ color: statusColor, backgroundColor: statusBg, padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold' }}>{statusText}</span>
                    </div>
                  </div>
                  <div className="flex flex-h-end" style={{ padding: '10px 15px', backgroundColor: '#f8f9fa', borderTop: '1px solid #eee' }}>
                    {!loadingReport ? (
                      <RiEdit2Fill
                        onClick={() => continueUpdate(row)}
                        className="pointer"
                        style={{ width: '24px', height: '24px', color: '#3C7E2D' }}
                      />
                    ) : <Skeleton width={24} height={24} />}
                  </div>
                </div>
              )
            })
          )}
        </div>
        {/* Modals are rendered outside the main return based on state */}
      </div>
    )
  }

  return (
    <div className="w-100">
      <div className=" tabs m-t-10 bold-text"></div>

      <div className="w-100 none-flex-item m-t-40">
        {!isWalkin ?
          <table className="bordered-table">
            <thead className="border-top-none">
              <tr className="border-top-none">
                <th className="center-text">Patient's Id</th>
                <th className="center-text">First Name</th>
                <th className="center-text">Last Name</th>
                <th className="center-text">Lab Work Requested</th>
                <th className="center-text">Diagnosis</th>
                <th className="center-text">Doctor</th>
                <th className="center-text">Status</th>
                <th className="center-text">Date Created</th>
                <th className="center-text">Time</th>
                <th className="center-text">Procedure Status</th>
                <th className="center-text">Action</th>
              </tr>
            </thead>
            {loading ?
              <TableSkeleton primary={5} secondary={9} /> : <tbody className="white-bg view-det-pane">
                {Array.isArray(data) && data?.map((row, index) => (
                  <tr className="pointer hovers" key={row?.id}>
                    <td>{row?.patient?.id}</td>
                    <td>{row?.patient?.firstName}</td>
                    <td>{row?.patient?.lastName}</td>
                    <td>
                      {
                        row?.testRequests?.map((work, i) => (
                          <div className="m-b-5" key={i}>{i + 1}. {work?.referredInternalLabService?.name}</div>
                        ))
                      }
                    </td>
                    <td>{row?.diagnosis}</td>
                    <td>{row?.doctor?.firstName} {row?.doctor?.lastName}</td>
                    <td>{row?.status}</td>
                    <td>{new Date(row?.createdAt).toLocaleDateString()}</td>
                    <td>{new Date(row?.createdAt).toLocaleTimeString()}</td>
                    {renderCompletionBanner(row)}
                    <td>
                      <span style={{ color: '#3C7E2D' }} className="flex flex-h-center">
                        <RiEdit2Fill
                          onClick={() => continueUpdate(row)}
                          className="pointer"
                          style={{ width: '24px', height: '24px' }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>}
          </table>
          :
          <table className="bordered-table">
            <thead className="border-top-none">
              <tr className="border-top-none">
                <th className="center-text">Lab Id</th>
                <th className="center-text">Patient Name</th>
                {/* <th className="center-text">Last Name</th> */}
                <th className="center-text">Lab Work Requested</th>
                {/* <th className="center-text">Diagnosis</th> */}
                {/* <th className="center-text">Doctor</th> */}
                {/* <th className="center-text">Status</th> */}
                <th className="center-text">Date Created</th>
                <th className="center-text">Time Created</th>
                <th className="center-text">Procedure Status</th>
                <th className="center-text">Action</th>
              </tr>
            </thead>
            {loading ?
              <TableSkeleton primary={5} secondary={4} /> : <tbody className="white-bg view-det-pane">
                {Array.isArray(data) && data?.map((row, index) => (
                  <tr className="pointer hovers" key={row?.id}>
                    <td>{row?.walkInPatient?.walkInPatientRef}</td>
                    <td>{(row?.walkInPatient?.firstName + " " + row?.walkInPatient?.lastName) || row?.patientFullName}</td>
                    {/* <td>{row?.patient?.lastName}</td> */}
                    <td>
                      {(row?.patientTestReports?.map((work, i) => (
                        <div className="m-b-5" key={i}>{i + 1}. {work?.internalLabService?.name}</div>
                      )))}
                    </td>
                    {/* <td>{row?.comment}</td> */}
                    {/* <td>{row?.doctor?.firstName} {row?.doctor?.lastName}</td> */}
                    {/* <td>{row?.status}</td> */}
                    <td>{new Date(row?.createdOn).toLocaleDateString()}</td>
                    <td>{new Date(row?.createdOn).toLocaleTimeString()}</td>
                    {renderCompletionBanner(row)}
                    <td>
                     {!loadingReport ? <span style={{ color: '#3C7E2D' }} className="flex flex-h-center">
                        <RiEdit2Fill
                          onClick={() => continueUpdate(row)}
                          className="pointer"
                          style={{ width: '24px', height: '24px' }}
                        />
                      </span> : <Skeleton/>}
                    </td>
                  </tr>
                ))}
              </tbody>}
          </table>
        }
      </div>
      {
        showReportModal &&
        <LabReportTable
          closeModal={() => setShowReportModal(false)}
          patientInfo={referralInfo}
          vitalInfo={referralInfo.vital}
          walkin={isWalkin}
          open={showReportModal}
          color={color}
          template={template}
          currentTemplate={currentTemplate}
          onClose={() => setShowReportModal(false)}
        />
      }

      {
        showProcedureEditModal &&
        <ProcedureEditsModal
          open={showProcedureEditModal}
          closeModal={() => setShowProcedureEditModal(false)}
          patientInfo={referralInfo}
          referredPatients={referredPatients}
          referralId={referralId}
          readOnly={readOnly}
          getProcedures={getProcedures}
          walkin={false}
        />
      }
    </div>
  );
};
